/**
 * What's new — the release notes this reader may see (`lib/release-notes.ts`
 * holds the notes and every rule). Drawn inside the ☰ menu's dialog.
 */

import { noteDate, type ReleaseNote } from "../lib/release-notes";

export function WhatsNew({ notes }: { notes: ReleaseNote[] }) {
  if (notes.length === 0) return <div style={EMPTY}>Nothing new yet.</div>;
  return (
    <div style={LIST} data-whats-new>
      {notes.map((note) => (
        <section key={note.id}>
          <div style={DATE}>{noteDate(note.date)}</div>
          <ul style={ITEMS}>
            {note.items.map((item, i) => (
              <li key={i} style={ITEM}>
                {item.text}
                {item.where && <div style={WHERE}>{item.where}</div>}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}

const LIST: React.CSSProperties = {
  width: "min(420px, calc(100vw - 32px))",
  maxHeight: "60vh",
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "0.75rem",
  fontSize: "0.82rem",
  color: "var(--qf-text)",
};

const DATE: React.CSSProperties = {
  fontSize: "0.7rem",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: "var(--qf-text-muted)",
  marginBottom: "0.25rem",
};

const ITEMS: React.CSSProperties = { margin: 0, paddingLeft: "1.1rem" };

const ITEM: React.CSSProperties = { marginBottom: "0.4rem", lineHeight: 1.4 };

const WHERE: React.CSSProperties = { fontSize: "0.74rem", color: "var(--qf-text-secondary)" };

const EMPTY: React.CSSProperties = { fontSize: "0.82rem", color: "var(--qf-text-muted)" };
